import { Navigate, Outlet } from 'react-router-dom';

import { Box, SxProps, Theme } from '@mui/material';

import { useUserDataStore } from '../../newStore/userDataStore';
import { paths } from '../../utils/navigation';
import { OverlayLoader } from '../uiComponents/CommonComponents/OverlayLoader';
import { UserNav } from './UserNav';

const customStyles: Record<string, SxProps<Theme>> = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    background: (theme) => theme.palette.background.default,
  },
  header: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '16px 24px',
    backgroundColor: (theme) => theme.palette.common.white,
    borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
  },
  content: {
    flexGrow: 1,
    overflow: 'auto',
  },
};

export function OnboardingTemplatesLayout() {
  const { currentUser, fetchedUserData, loading } = useUserDataStore();

  if (loading && !fetchedUserData) return <OverlayLoader open />;

  if (!currentUser?.id && !currentUser?.is_support && fetchedUserData)
    return (
      <Navigate
        to={paths.auth.login}
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );

  return (
    <Box sx={customStyles.root}>
      <Box sx={customStyles.header}>
        <UserNav />
      </Box>
      <Box sx={customStyles.content}>
        <Outlet />
      </Box>
    </Box>
  );
}
